import React, { useContext } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function SectionContainer({
  name,
  ...props
}: BoxProps & { name: string }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: sp.s80,
        ...props.sx,
      }}
    >
      <Typography sx={{ fontWeight: 'bold' }} variant="f28">
        Раздел: {name}
      </Typography>
      {props.children}
    </Box>
  );
}
